import { graphql } from "~/gql";
export const UPDATE_DISBURSEMENT = graphql(/* GraphQL */ `
  mutation updateDisbursement($disbursement: UpdateDisbursementInput!) {
    updateDisbursement(disbursement: $disbursement) {
      ...DisbursementParts
    }
  }
`);

export const UPDATE_DISBURSEMENTS = graphql(/* GraphQL */ `
  mutation updateDisbursements($data: [DisburmentUpdate!]!) {
    updateDisbursements(data: $data) {
      ...DisbursementParts
    }
  }
`);
